import RequestHelpler from '@/utils/methods/request';
import * as questionnaireService from '@/services/questionnaire.service';
import { getLocationId} from '@/services/questionnaire.service';

import {
  SET_ERROR,
  SET_LEAD,
  SET_LEAD_WIZARD,
  SET_LEAD_WIZARD_ERROR,
  SET_CUR_MODE,
} from './mutation-types';

export default {
  getLead(context, leadId) {
    if(context.state.mode==2)
      return
    return RequestHelpler.sendRequest({
      url: `/lead2/${leadId}`,
      method: 'query',
      mutation: SET_LEAD,
      errorMutation: SET_ERROR,
      context,
    });
  },

  async addLead(context, lead) {
    if(context.state.mode==2)
      return
    const result = await RequestHelpler.sendRequest({
      url: `/lead2/add/${getLocationId()}`,
      method: 'post',
      data: lead,
      mutation: SET_LEAD,
      errorMutation: SET_ERROR,
      context,
    });

    if (result.LeadId) {
      questionnaireService.saveLeadId(result.LeadId);
    }

    return result;
  },

  updateLead(context, lead) {
    if(context.state.mode==2)
      return
    if (lead.LeadId) questionnaireService.saveLeadId(lead.LeadId);

    return RequestHelpler.sendRequest({
      url: `/lead2/${lead.LeadId}/update/${getLocationId()}`,
      method: 'post',
      data: lead,
      mutation: SET_LEAD,
      errorMutation: SET_ERROR,
      context,
      useProp: true,
    });
  },

  mutateLead({ commit }, lead) {
    if (lead.LeadId) questionnaireService.saveLeadId(lead.LeadId);
    commit(SET_LEAD, lead);
    return lead;
  },

  getLeadWizard(context, leadWizardId) {
    return RequestHelpler.sendRequest({
      url: `/lead2wizard/${leadWizardId}`,
      method: 'query',
      mutation: SET_LEAD_WIZARD,
      errorMutation: SET_LEAD_WIZARD_ERROR,
      context,
    });
  },

  updateMode(context,mode){
    context.commit(SET_CUR_MODE,mode)
  },

};
